










import Vue, { PropType } from 'vue';
import CustomerOrderDetailDto from '@/models/CustomerOrderDetailDto';

export default Vue.extend({
  props: {
    order: {
      type: Object as PropType<CustomerOrderDetailDto>,
      required: true,
    },
  },
  computed: {
    status(): string {
      return this.$t('pages.owner.ownerOrderDetail.orderStatus.' + this.order.status).toString();
    },
    shortOrderId(): string {
      return this.order.orderId.split('-')[0];
    },
  },
});
